import {fetch} from "utils/dataAccess";

export async function downloadExport(startDate = null, endDate = null) {
    let params = '';

    if (null !== startDate) params += `&startDate=${startDate.format("Y-M-D")}`;
    if (null !== endDate) params += `&endDate=${endDate.format("Y-M-D 23:59:59")}`;

    return await fetch(`/picking/order/export?${params}`, {method: 'GET'});
}

export async function downloadExportLineItem(startDate = null, endDate = null) {
    let params = '';

    if (null !== startDate) params += `&startDate=${startDate.format("Y-M-D")}`;
    if (null !== endDate) params += `&endDate=${endDate.format("Y-M-D 23:59:59")}`;

    return await fetch(`/picking/lineItem/export?${params}`, {method: 'GET'});
}
